import SelectedQuestions from './SelectedQuestions';
export default SelectedQuestions;
